import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import {
  Portlet,
  PortletBody,
//  PortletHeader,
//  PortletHeaderToolbar
} from "../../partials/content/Portlet";
import { metronic } from "../../../_metronic";
import QuickStatsChart from "../../widgets/QuickStatsChart";
import AccountTiles from "../../widgets/AccountTiles";
import Banner from "../../widgets/Banner";
import StatusTiles from "../../widgets/StatusTiles";
import OrderStatusTiles from "../../widgets/OrderStatusTiles";

import OrderStatisticsChart from "../../widgets/OrderStatisticsChart";
import OrdersWidget from "../../widgets/OrdersWidget";
import SalesBarChart from "../../widgets/SalesBarChart";
import DownloadFiles from "../../widgets/DownloadFiles";
import NewUsers from "../../widgets/NewUsers";
import LatestUpdates from "../../widgets/LatestUpdates";
import BestSellers from "../../widgets/BestSellers";
import RecentActivities from "../../widgets/RecentActivities";
import CalendarEvents from "../../widgets/CalendarEvents";
import AuthorsProfit from "../../widgets/AuthorsProfit";

import { getMenus,addUserToken,vapidKey } from "../../crud/auth.crud";


import { getFirebaseMessaging } from '../../firebase/firebase';

import { getToken, onMessage } from 'firebase/messaging';

export default function Dashboard() {

  const [permissions,setPermissions] =useState({permission:''});
  
  React.useEffect(() => {
        const fetchPermissions = async () => {
            try {
                //setPermissions({roles: rolesData.roles, isLoading: true});
                const response = await getMenus()
                if(response.data[0] != null && response.data[0].permissions !=null)
                {
                 
                  console.log(response.data[0].permissions);
                  let perms="";
                  response.data[0].permissions.map((per) =>(
                    perms = perms + "," + per
                    ))
                  console.log(perms);
                   setPermissions({permission: perms});

                }
            } catch (e) {
                console.log(e);
                //setPermissions({roles: rolesData.roles, isLoading: false});
            }
        };
        fetchPermissions();
    }, []);


React.useEffect(() => {
        const enablePushNotifications = async () => {
            try {

               const permission = await Notification.requestPermission();
                if (permission !== 'granted') {
                  console.log('Notification permission not granted');
                  return;
                }
                const messaging = await getFirebaseMessaging();
                if (!messaging) return;
 
 
                // Get token
              const currentToken = await getToken(messaging, { vapidKey });
              if (currentToken) {
                console.log('FCM Token:', currentToken);
               // await sendFcmTokenToBackend(currentToken);
                const response = await addUserToken(currentToken);
              } else {
                console.log('No token available');
              }

                
            } catch (e) {
                console.log(e);
                //setPermissions({roles: rolesData.roles, isLoading: false});
            }
        };
        enablePushNotifications();
    }, []);


  const { brandColor, dangerColor, successColor, primaryColor } = useSelector(
    state => ({
      brandColor: metronic.builder.selectors.getConfig(
        state,
        "colors.state.brand"
      ),
      dangerColor: metronic.builder.selectors.getConfig(
        state,
        "colors.state.danger"
      ),
      successColor: metronic.builder.selectors.getConfig(
        state,
        "colors.state.success"
      ),
      primaryColor: metronic.builder.selectors.getConfig(
        state,
        "colors.state.primary"
      )
    })
  );

  const chartOptions = useMemo(
    () => ({
      chart1: {
        data: [10, 14, 18, 11, 9, 12, 14, 17, 18, 14],
        color: brandColor,
        border: 3
      },

      chart2: {
        data: [11, 12, 18, 13, 11, 12, 15, 13, 19, 15],
        color: dangerColor,
        border: 3
      },

      chart3: {
        data: [12, 12, 18, 11, 15, 12, 13, 16, 11, 18],
        color: successColor,
        border: 3
      },

      chart4: {
        data: [11, 9, 13, 18, 13, 15, 14, 13, 18, 15],
        color: primaryColor,
        border: 3
      }
    }),
    [brandColor, dangerColor, primaryColor, successColor]
  );

  return (

    <>


     
      <Banner/>
      

      {(permissions.permission.includes("WIDGETADMIN") &&
     
      <AccountTiles />
      )}

      {(permissions.permission.includes("WIDGETSTATUS") &&
         <StatusTiles />
      )}
      {(permissions.permission.includes("ORDER:WIDGETS") &&
         <OrderStatusTiles />
      )}

     {(permissions.permission.includes("SALES:WIDGET") &&
      <>
      

      </>
     )}

      
       
    </>
  );
}
